export default __webpack_public_path__ + "locales/ja-JP/DownloadDialog.json?hash=dfd41e3ab43de8b57e48882abdc0628a";